import React from 'react';
import { IIcon } from '../../@types/icons';
import { defaultTheme } from './../../styles/theme/default';

function Refresh ({ strokeColor = 'verdigris', size = 16 }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g
        stroke={defaultTheme.colors[strokeColor]}
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#clip0_20801_861)"
      >
        <path d="M12.57 10.286l2.286-.572.572 2.286" />
        <path d="M14.857 9.714A7.725 7.725 0 018 14.857a6.856 6.856 0 01-6.445-4.514M3.427 5.714l-2.285.572L.57 4" />
        <path d="M1.14 6.286c.96-2.629 3.91-5.143 6.858-5.143a6.857 6.857 0 016.446 4.571" />
      </g>
      <defs>
        <clipPath id="clip0_20801_861">
          <path fill="#fff" d="M0 0H16V16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Refresh;
